import { Globe, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-[#092953] text-white pt-5">
      <div className="container">
        <div className="row gy-4 pb-4">

          {/* COMPANY INFO */}
          <div className="col-lg-4 col-md-6">
            <div className="d-flex align-items-center gap-3 mb-3">
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  background: "#fff",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#092953",
                  fontWeight: "700"
                }}
              >
                IGT
              </div>
              <div>
                <div className="fw-semibold">
                  Imagenators Global Technology Pvt. Ltd.
                </div>
                <div style={{ fontSize: "0.8rem", opacity: 0.7 }}>
                  Technology • Innovation • Growth
                </div>
              </div>
            </div>

            <p style={{ fontSize: "0.9rem", opacity: 0.8 }}>
              CIN: U62099UP2025PTC223917
            </p>

            <div style={{ fontSize: "0.9rem" }}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <Globe size={16} />
                <a
                  href="https://www.igttech.com"
                  className="text-white text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.igttech.com
                </a>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <Mail size={16} />
                <a
                  href="mailto:info@igttech.com"
                  className="text-white text-decoration-none"
                >
                  info@igttech.com
                </a>
              </div>

              <div className="d-flex align-items-center gap-2">
                <Phone size={16} />
                <span>+91-9837741802</span>
              </div>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-semibold mb-3 border-bottom border-light pb-2 d-inline-block">
              Quick Links
            </h5>

            <ul className="list-unstyled">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Services", path: "/services" },
                { name: "Training Programs", path: "/training" },
                { name: "Government & Education", path: "/government-education" },
                { name: "Careers", path: "/careers" },
                { name: "Contact Us", path: "/contact" }
              ].map((item, index) => (
                <li key={index} className="mb-2">
                  <Link
                    to={item.path}
                    className="text-white text-decoration-none"
                  >
                    › {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* SERVICES */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-semibold mb-3 border-bottom border-light pb-2 d-inline-block">
              Services
            </h5>

            <ul className="list-unstyled">
              {[
                "IT Services & Consulting",
                "Software & Application Development",
                "Cloud & DevOps Solutions",
                "Artificial Intelligence Solutions",
                "ERP Solutions & Implementation"
              ].map((service, index) => (
                <li key={index} className="mb-2">
                  › {service}
                </li>
              ))}
            </ul>
          </div>

          {/* CONNECT */}
          <div className="col-lg-2 col-md-6">
            <h5 className="fw-semibold mb-3 border-bottom border-light pb-2 d-inline-block">
              Connect With Us
            </h5>

            <div className="d-flex flex-column gap-2">
              <Link
                to="/contact"
                className="btn btn-light btn-sm"
              >
                Get In Touch
              </Link>

              <Link
                to="/careers"
                className="btn btn-outline-light btn-sm"
              >
                Careers
              </Link>
            </div>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="border-top border-light pt-3 text-center small opacity-75 pb-3">
          © 2026 Imagenators Global Technology Private Limited. All rights reserved.
        </div>
      </div>
    </footer>
  );
}